import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getFrasesByPlantelThunk,
  getTalentsSelectorByPlantelThunk,
} from "../../store/reducers/plantels/plantels.thunks";
import Loader from "../UI/Loader";
import FrasesTable from "./FrasesTable";
import Pagination from "../UI/Pagination";
import { setFrasesPage } from "../../store/reducers/plantels/phrasesByPlantel.reducer";
import FrasesFilters from "./FrasesFilters";
import PhraseByPlantelFormModal from "./PhraseByPlantelFormModal";
import PhraseByPlantelViewModal from "./PhraseByPlantelViewModal";
import ConfirmTogglePhraseModal from "./ConfirmTogglePhraseModal";

const FrasesTab = ({ plantelId }) => {
  const dispatch = useDispatch();
  const { list, page, filters, loading, count, pageSize } = useSelector(
    (s) => s.frasesByPlantel,
  );

  useEffect(() => {
    if (!plantelId) return;

    if (filters.isRandom) {
      dispatch(
        getFrasesByPlantelThunk({
          plantelId,
          isRandom: true,
        }),
      );
    } else {
      dispatch(
        getFrasesByPlantelThunk({
          plantelId,
          talentoPlantelId: filters.talentoPlantelId,
          page,
        }),
      );
    }
  }, [plantelId, filters, page, dispatch]);

  useEffect(() => {
    if (plantelId) {
      dispatch(getTalentsSelectorByPlantelThunk(plantelId));
    }
  }, [plantelId, dispatch]);
  return (
    <>
      <FrasesFilters plantelId={plantelId} />
      <PhraseByPlantelFormModal plantelId={plantelId} />
      {loading ? (
        <Loader center text="Cargando frases..." />
      ) : (
        <>
          <FrasesTable frases={list} />
          <PhraseByPlantelViewModal />
          <ConfirmTogglePhraseModal />
        </>
      )}

      <Pagination
        page={page}
        count={count}
        pageSize={pageSize}
        onPageChange={(p) => dispatch(setFrasesPage(p))}
      />
    </>
  );
};

export default FrasesTab;
